<template lang="pug">
  .blog
    top-nav(headerColor="white")
    .placeholder(v-if="loading")
    transition(name="fade")
      .content.year.month(v-if='!loading')
        .grid
          .col-3_xs-12
            .titles
              h2.h-l
                | learn
              router-link(:to="{name: 'blog'}")
                h1.h-xl.category
                  | 600state
              h3.h-sm.desc
                | {{ description }}
              router-link(v-for="cat in categories" :to="categoryLink(cat)" :key="cat")
                h3.h-sm.cat(:class="{ active: catActive(cat) }") {{ cat }}
          .col-9_xs-12
            .grid.no-margin
              .col-12_xs-12.featured(v-if="currentIndex === 0 && featuredActive === 'active'")
                router-link(:to="{name: 'article', params: {category: getCat(featuredMain), article: featuredMain.uid }}")
                  .screen-blog-featured
                    img.cover(v-if="hero(featuredMain)" :src="heroImage(featuredMain)" :alt="heroCaption(featuredMain)")
                    .captions
                      h2.h-l.lh-95.title(v-html="checkTitle(featuredMain)")
                      h2.h-md.author(v-if="featuredMain.content.author.length > 0")
                        | {{ featuredMain.content.author }} </br>
                        | {{ featuredMain.content.date }}
                      h2.h-md.author(v-else)
                        | {{ featuredMain.content.date }}
              .col-6_xs-12.featured(v-for="post in featured" v-if="currentIndex === 0 && featuredActive === 'active'")
                router-link(:to="{name: 'article', params: {category: getCat(post), article: post.uid }}")
                  .screen-small
                    img.cover(v-if="hero(post)" :src="heroImage(post)" :alt="heroCaption(post)")
                    .captions
                      h2.h-l.lh-95.title(v-html="checkTitle(post)")
                      h2.h-md.author(v-if="post.content.author.length > 0")
                        | {{ post.content.author }} </br>
                        | {{ post.content.date }}
                      h2.h-md.author(v-else)
                        | {{ post.content.date }}
              .col-6_xs-12(v-for="post in posts")
                router-link(:to="{name: 'article', params: {category: getCat(post), article: post.uid }}")
                  .screen-small
                    img.cover(v-if="hero(post)" :src="heroImage(post)" :alt="heroCaption(post)")
                    .captions
                      h2.h-l.lh-95.title(v-html="checkTitle(post)")
                      h2.h-md.author(v-if="post.content.author.length > 0")
                        | {{ post.content.author }} </br>
                        | {{ post.content.date }}
                      h2.h-md.author(v-else)
                        | {{ post.content.date }}
        .grid
          .col-3_xs-12
          .col-9_xs-12
            .index
              p(
                v-for="page in numPages"
                :class="{ active: active(page)}"
                @click="loadPage(page)"
              )
                | {{ page + 1 }}
    bottom-nav(footerColor="white")
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
import ComponentMixin from '@/mixins/ComponentMixin'
import UtilsMixin from '@/mixins/UtilsMixin'

export default {
  name: 'blog',
  mixins: [DataMixin, ComponentMixin, UtilsMixin],

  data () {
    return {
      loading: false,
      loadedData: [],
      catSlug: false,
      // url: 'http://localhost:8888/caam/caam_live/api/blog/',
      url: 'https://caamuseum.org/api/articles',
      offset: 0,
      limit: 10,
      currentIndex: 0
    }
  },

  created () {
    // this.index = this.months.indexOf(this.month)
    this.catSlug = this.$route.params.category
    this.getData()
  },

  methods: {
    active: function (num) {
      return num === this.currentIndex
    },

    categoryLink: function (cat) {
      return {
        name: 'blog-category',
        params: {
          category: this.slugify(cat)
        }
      }
    },

    catActive: function (cat) {
      return this.slugify(cat) === this.catSlug
    },

    getCat (post) {
      let cat
      if (post.content.category && !this.catSlug) {
        cat = post.content.category.split(', ')[0]
      } else if (this.catSlug) {
        cat = this.catSlug
      } else {
        cat = 'black-history'
      }
      return this.slugify(cat)
    },

    getData: function () {
      const page = '?offset=' + this.offset + '&limit=' + this.limit
      const url = this.catSlug ? this.url + '/' + this.catSlug + page : this.url + page
      this.loading = true
      this.get(url, response => {
        this.loading = false
        this.loadedData = response.data
      })
    },

    hero: function (post) {
      const name = post.content.main_image
      const files = post.files
      if (name.length > 0) {
        return files.find(item => item.filename === name)
      } else {
        return false
      }
    },

    heroImage (post) {
      const hero = this.hero(post)
      return hero.url
    },

    heroCaption: function (post) {
      let hero = this.hero(post)
      return hero.meta.caption
    },

    checkTitle: function (post) {
      if (post.content.short_title) {
        if (post.content.short_title.length > 0) {
          return post.content.short_title
        } else {
          return post.content.title
        }
      } else {
        return post.content.title
      }
    },

    loadPage: function (num) {
      this.currentIndex = num
      this.offset = num * this.limit
      this.getData()
      window.scrollTo(0, 0)
    }
  },

  computed: {
    categories: function () {
      return this.loadedData.categories.split(',')
    },

    description: function () {
      return this.loadedData.description
    },

    featuredMain: function () {
      return this.loadedData.featured[0]
    },

    featured: function () {
      let fC = this.loadedData.featured ? [...this.loadedData.featured] : []
      return fC.slice(1)
    },

    featuredActive: function () {
      return this.loadedData.featured_active
    },

    posts: function () {
      return this.loadedData.posts
    },

    numPages: function () {
      const total = Math.ceil(this.loadedData.total / this.limit)
      return total <= 1 ? [] : [...Array(total).keys()]
    }
  },

  watch: {
    loaded () {
      if (this.loaded) {
        window.scrollTo(0, 0)
      }
    },

    $route () {
      this.catSlug = this.$route.params.category
      this.getData()
    }
  }
}
</script>

<style lang="sass">
  @import '../styles/_mixins'
  @import '../styles/_variables'
  .blog
    .content
      padding-top: 0
      @include respond-to(xs)
        padding-top: 0rem
      .titles
        width: 80%
        h1
          padding-top: 4rem
          @include respond-to(xs)
            padding-top: 2rem
        ul
          margin-top: 4rem
          @include respond-to(xs)
            margin-top: 0rem
        h3
          margin-bottom: 0.5rem
          &.cat
            cursor: pointer
            margin-bottom: 0.5rem
            padding: 0
            color: $learn
            &.active
              color: $exhibitions
          &.date
            color: $learn
            cursor: crosshair
        .category
          padding-bottom: 2rem
        .desc
          padding-bottom: 2rem
          color: $learn
      .category
        color: $learn
      .screen-small
        .captions
          h2
            &:nth-of-type(1)
              padding: 0 0 10rem 3.3rem
              @include respond-to(xs)
                padding: 0 0 7.7rem 1rem
    .index
      margin-top: 4rem
      display: flex
      @include respond-to(xs)
        margin-top: 0
      p
        margin-right: 2rem
        cursor: pointer
        &.active
          border-bottom: solid 2px #000
</style>



// WEBPACK FOOTER //
// Blog.vue?6c72de6e